import script from "./ConfirmSocketDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmSocketDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmSocketDialog.vue?vue&type=style&index=0&id=4501f77a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4501f77a"]])

export default __exports__